import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetMeQuery = {
  __typename?: 'Query';
  getMe: {
    __typename?: 'GetMeResponse';
    additionalRoles?: string | null;
    email: string;
    eventRole?: string | null;
    firstName: string;
    lastName: string;
    licenseNumber?: string | null;
    note?: string | null;
    organizationName?: string | null;
    phone?: string | null;
    policyCoverage?: string | null;
    privileges: Array<string>;
    relevantCertifications?: string | null;
    status: string;
    uuid: string;
    roleName: string;
    isTermsAndConditionsAccepted: boolean;
    preferredTimezone?: string | null;
    timezoneDisplayPreference: Types.PersonTimezoneDisplayPreference;
    lastSelectedOrganization?: {
      __typename?: 'LastSelectedOrganizationResponse';
      name: string;
      uuid: string;
    } | null;
    lastSelectedClientGroup?: {
      __typename?: 'LastSelectedClientGroupResponse';
      name: string;
      uuid: string;
    } | null;
    customizations?: Array<{
      __typename?: 'GetMePersonCustomizationResponse';
      dateValue?: string | null;
      description?: string | null;
      name: string;
      textValue?: string | null;
      type: string;
      uuid: string;
    }> | null;
  };
};

export const GetMeDocument = gql`
  query GetMe {
    getMe {
      additionalRoles
      email
      eventRole
      firstName
      lastName
      licenseNumber
      note
      organizationName
      phone
      policyCoverage
      privileges
      relevantCertifications
      status
      uuid
      roleName
      isTermsAndConditionsAccepted
      lastSelectedOrganization {
        name
        uuid
      }
      lastSelectedClientGroup {
        name
        uuid
      }
      customizations {
        dateValue
        description
        name
        textValue
        type
        uuid
      }
      preferredTimezone
      timezoneDisplayPreference
    }
  }
`;
export function useGetMeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options,
  );
}
export function useGetMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options,
  );
}
export function useGetMeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options,
  );
}
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<
  typeof useGetMeSuspenseQuery
>;
export type GetMeQueryResult = Apollo.QueryResult<
  GetMeQuery,
  GetMeQueryVariables
>;
export function refetchGetMeQuery(variables?: GetMeQueryVariables) {
  return { query: GetMeDocument, variables: variables };
}
